export default __webpack_public_path__ + "static/media/service5.0d394fcb.png";